import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FileForUserListItem } from '../../../../modules/shared/models/api.model';
import { DocumentService } from '../../../../modules/shared/services/document/document.service';
import { ToasterService } from 'src/app/modules/shared/services/toaster/toaster.service';
import { saveAs } from 'file-saver';

@Component({
  selector: 'saffron-list-item',
  templateUrl: './file-list-item.component.html',
  styleUrls: ['./file-list-item.component.scss']
})
export class FileListItemComponent {
  @Input() file!: FileForUserListItem;
  @Output() fileDeleted = new EventEmitter<void>();
  @Output() selected = new EventEmitter<string>();
  @Input() showActions: boolean = true;

  constructor(
    private documentService: DocumentService,
    private Toaster: ToasterService,
  ) {}

  // Derive file extension from ORIGINAL_FILENAME or GENERATED_FILENAME
  get extension(): string {
    const name = this.file?.ORIGINAL_FILENAME || this.file?.GENERATED_FILENAME || '';
    const idx = name.lastIndexOf('.');
    return idx >= 0 ? name.substring(idx + 1).toLowerCase() : '';
  }

  public onSelect() {
    const id = (this.file as any)?.FILE_ID?.toString?.() || (this.file as any)?.GENERATED_FILENAME || '';
    if (id) this.selected.emit(id);
  }

  public async downloadFile() {
    try {
      const key = this.file?.GENERATED_FILENAME || this.file?.FILE_ID;
      const response = await this.documentService.getDocumentAccess(key, 'download');
      if (response?.url) {
        // Use file-saver to handle the download
        const suggestedName = this.file?.ORIGINAL_FILENAME || this.file?.GENERATED_FILENAME || 'downloaded-file';
        saveAs(response.url, suggestedName);
      } else {
        this.Toaster.warning('Failed to retrieve the download URL.');
      }
    } catch (error) {
      console.log('Error downloading file:', error);
      this.Toaster.warning('Error downloading file: ' + error);
    }
  }

  public async deleteFile() {
    const filename = this.file?.ORIGINAL_FILENAME || this.file?.GENERATED_FILENAME || '';
    if (confirm(`Are you sure you want to delete ${filename}?`)) {
      
      try {
        const key = this.file?.GENERATED_FILENAME || this.file?.FILE_ID;
        await this.documentService.deleteFile(key);
        this.Toaster.success('File deleted successfully.');
        this.fileDeleted.emit();
        
      } catch (error) {
        this.Toaster.warning('Error deleting file: ' + error);
      }
    }
  }

}
